import React, { Component } from "react";
import { FormGroup,
        FormControl,
        Tabs,
        Tab,
        ToggleButtonGroup,
        ToggleButton} from "react-bootstrap";
import LoaderButton from "../components/LoaderButton";
import config from "../config";
import "./NewSummary.css";
import axios from 'axios';
import ReactGA from 'react-ga';


export default class NewSummary extends Component {
  constructor(props) {
    super(props);

    this.file = null;

    this.initializeReactGA();

    this.state = {
      basicAuth: this.props.basicAuth,
      userId: this.props.userId,
      isLoading: null,
      content: localStorage.getItem('cache_originalText'),
      topicFocus: this.getTopicFocus(),
      topicPercent: this.getTopicPercent(),
      inputType: "text",
      summaryStatus: null,
      url: localStorage.getItem('cache_url')
    };
  }

  initializeReactGA() {
    ReactGA.initialize('UA-136595020-1');
    ReactGA.pageview('/NewSummary');
  }

  toSignup() {
    this.props.history.push("/signup");
  }

  validateForm() {
    return (this.state.content.length > 0 || this.file !== null);
  }

  getTopicFocus() {
    if (!localStorage.getItem('cache_topicFocus')) {
      return 'none'
    } else {
      return localStorage.getItem('cache_topicFocus')
    }
  }

  getTopicPercent() {
    if (!localStorage.getItem('cache_topicPercent')) {
      return 0.5
    } else {
      return localStorage.getItem('cache_topicPercent')
    }
  }

  handleTopicFocusChange = event => {
    if (event[1]){
      this.setState({ topicFocus: event[1] });
      localStorage.setItem('cache_topicFocus', event[1])
    }
  }

  handleChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
  }

  handleContentChange = event => {
    this.setState({
      [event.target.id]: event.target.value
    });
    localStorage.setItem('cache_originalText', event.target.value)
  }

  handleUrlChange = event => {
    this.setState({ url: event.target.value });
    localStorage.setItem('cache_url', event.target.value)
  }

  handleSliderChange = event => {
    this.setState({topicPercent: event.target.value});
    localStorage.setItem('cache_topicPercent', event.target.value)
  }

  handleFileChange = event => {
    this.file = event.target.files[0];
    console.log(this.file !== null);
  }

  handleSubmit = event => {
    event.preventDefault();

    if (this.file && this.file.size > config.MAX_ATTACHMENT_SIZE) {
      alert(`Please pick a file smaller than ${config.MAX_ATTACHMENT_SIZE/1000000} MB.`);
      return;
    }

    this.setState({ isLoading: true });

    console.log('Input Type: ' + this.state.inputType);

    try {
      if (this.state.inputType === 'text') {
        this.createTextSummary({
          content: this.state.content
        });
      } else if (this.state.inputType === 'image'){
        this.createImageSummary(this.file);
      } else if (this.state.inputType === 'url'){
        this.createUrlSummary(this.state.url);
      }


    } catch (e) {
      alert(e);
      this.setState({ isLoading: false });
    }
  }


  createImageSummary(file) {

    ReactGA.event({
      category: 'User',
      action: 'Create Image Summary'
    });

    const formData = new FormData();
    formData.append('file',file)
    formData.append('topic_focus',this.state.topicFocus)
    formData.append('topic_percent',this.state.topicPercent)
    formData.append('user_id',localStorage.getItem('cache_userId'))

      axios.post(config.API_HOST + '/summary/run/image',
                 formData,
                 {headers: { 'Content-Type': 'multipart/form-data',
                            Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
      .then(res => {
        // Put response data in the console for now during dev
        console.log("Run summary response:")
        console.log(res.data);

        // store Summary info
        this.props.setSummary(res.data);

        console.log("Summary Id: ");
        console.log(localStorage.getItem('cache_summaryId'));

        // Pull the summary
        this.pollSummary(localStorage.getItem('cache_summaryId'), 0);
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert(e);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }

  createUrlSummary(url) {

    ReactGA.event({
      category: 'User',
      action: 'Create URL Summary'
    });

      axios.post(config.API_HOST + '/summary/run/url',
                 {url: url,
                  topic_focus: this.state.topicFocus,
                  topic_percent: this.state.topicPercent,
                  user_id: localStorage.getItem('cache_userId')},
                 {headers: { 'Content-Type': "application/json",
                            Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
      .then(res => {
        // Put response data in the console for now during dev
        console.log("Run summary response:")
        console.log(res.data);

        // store Summary info
        this.props.setSummary(res.data);

        console.log("Summary Id: ");
        console.log(localStorage.getItem('cache_summaryId'));

        // Pull the summary
        this.pollSummary(localStorage.getItem('cache_summaryId'), 0);
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert(e);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }

  createTextSummary(note) {

    ReactGA.event({
      category: 'User',
      action: 'Create Text Summary'
    });

      axios.post(config.API_HOST + '/summary/run/text',
                 {text: note.content,
                  topic_focus: this.state.topicFocus,
                  topic_percent: this.state.topicPercent,
                  user_id: localStorage.getItem('cache_userId')},
                 {headers: { 'Content-Type': "application/json",
                            Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
      .then(res => {
        // Put response data in the console for now during dev
        console.log("Run summary response:")
        console.log(res.data);

        // store Summary info
        this.props.setSummary(res.data);

        console.log("Summary Id: ");
        console.log(localStorage.getItem('cache_summaryId'));

        // Pull the summary
        this.pollSummary(localStorage.getItem('cache_summaryId'), 0);
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert(e);
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }

  sleep(milliseconds) {
    var start = new Date().getTime();
    for (var i = 0; i < 1e7; i++) {
      if ((new Date().getTime() - start) > milliseconds){
        return Promise.resolve();
      }
    }
  }


  pollSummary(id, retries = 0) {

    console.log("Start Checking summary status...")

    // Need loop here to check and pull summary
      axios.post(config.API_HOST + '/summary/pull',
                 {summary_id: id},
                 {headers: { 'Content-Type': "application/json",
                            Authorization: "Basic " + localStorage.getItem('cache_basicAuth')}})
      .then(res => {
        // Put response data in the console for now during dev
        console.log("Check summary status:")
        console.log(res.data);


        if (res.data.status === "Complete") {

          // store Summary info
          this.setState({ summaryStatus: null});
          this.props.setSummary(res.data);
          this.setState({ isLoading: false });
          // Push user to summary view
          this.props.history.push("/summary/view");
          return Promise.resolve(res.data); // success!

        } else if (retries >= 300) {
          this.setState({ isLoading: false });
          this.setState({ summaryStatus: null});
          return Promise.reject(res); // failure

        } else if (res.data.status === "ERROR") {
          this.setState({ summaryStatus: "Error Please Refresh"});
          return Promise.reject(res); // failure

        } else {
          // try again after delay
          this.setState({ summaryStatus: res.data.status});
          this.sleep(1000)
          return this.pollSummary(id, retries + 1);
        }
      })
      .catch (e =>
        {console.log('error ' + e.message);
         alert('Sorry please try that again');
          // take down loading symbol
         this.setState({ isLoading: false });
        });
  }


  renderTopics() {
    return (
      <div className='TopicFocus' id="tile">
      <h2> Topic Focus </h2>
      <ToggleButtonGroup
        type="checkbox"
        value={this.state.topicFocus}
        onChange={this.handleTopicFocusChange}
      >
      <ToggleButton value={'people'}>People</ToggleButton>
      <ToggleButton value={'places'}>Places</ToggleButton>
      <ToggleButton value={'organizations'}>Orgs</ToggleButton>
      <ToggleButton value={'none'}>AutoDetect</ToggleButton>
      </ToggleButtonGroup>
      </div>
    );
  }


  renderTabs() {
    return (
      <Tabs
        id="input-selection"
        activeKey={this.state.inputType}
        onSelect={inputType => this.setState({ inputType })}
      >
        <Tab eventKey="text" title="Copy/Paste">
          <FormGroup controlId="content">
            <h2 align='left'>Text </h2>
              <h4 align='left'> Need the digital book?
                <a href="https://ebooks.adelaide.edu.au/meta/titles/A.html">
                  <u>Check Here</u> </a>
              </h4>
            <FormControl
              rows="15" cols="50"
              onChange={this.handleContentChange}
              value={this.state.content}
              componentClass="textarea"
              placeholder='Enter text here to summarize...'
            />
          </FormGroup>
        </Tab>

        {this.state.isAuthenticated
          ?<Tab eventKey="image" title="PDF">
            <FormGroup controlId="file">
              <h2 align='left'>File</h2>
              <FormControl onChange={this.handleFileChange} type="file" />
            </FormGroup>
           </Tab>
          :<Tab eventKey="image" title="PDF">
            <h2 align="left"> Please sign up to use PDF upload  </h2>
            <LoaderButton
              block
              bsStyle="primary"
              bsSize="large"
              type="submit"
              isLoading={this.state.isLoading}
              text="Sign Up"
              loadingText="…"
              onClick={this.toSignup.bind(this)}
            />
           </Tab>}

        <Tab eventKey="url" title="URL / Link">
          <FormGroup controlId="file">
            <h2 align='left'>URL / Link</h2>
            <FormControl
            onChange={this.handleUrlChange}
            type="input"
            value={this.state.url}/>
          </FormGroup>
        </Tab>
      </Tabs>
    );
  }


  render() {

    return (
      <div className="NewSummary">

      <h2> Create Summary </h2>

      {this.renderTabs()}

      {this.renderTopics()}

        <form onSubmit={this.handleSubmit}>

        <div id="tile">
          <FormGroup controlId="summarySize">
            <h2 align='center'>Summary Size</h2>
            <table width='100%'>
            <tbody>
              <tr>
                <td align='left'> I've got 2 minutes </td>
                <td align='right'> Give me a bigger summary </td>
              </tr>
            </tbody>
            </table>
              <input
                id="typeinp"
                type="range"
                min="0.1" max="1"
                value={this.state.topicPercent}
                onChange={this.handleSliderChange}
                step="0.1"/>
          </FormGroup>
        </div>

          <LoaderButton
            block
            bsStyle="primary"
            bsSize="large"
            //disabled={!this.validateForm()}
            type="submit"
            isLoading={this.state.isLoading}
            text="Summarize"
            loadingText={this.state.summaryStatus}
          />
        </form>

      </div>
    );
  }
}
